/**
 * FirstPromoter referral token (read-only) — no third-party script.
 *
 * An affiliate link lands on the marketing site as `?fpr=<promoter_token>`.
 * That site captures the token into a first-party cookie on
 * `.newsquawk.com` (see the matching module in marketing-and-news-app,
 * which owns the write side), so it's readable here too. At checkout we
 * put it on the Chargebee customer as `cf_tid`, and FirstPromoter picks
 * it up via its existing Chargebee webhook integration.
 *
 * We deliberately don't load FirstPromoter's fpr.js anywhere — it's a
 * third-party script whose only job is registering clicks and minting a
 * `tid`. Commissions ride on the token, not the click record.
 */

const COOKIE_NAME = "nq_fpr_ref";

function readCookie(name: string): string | null {
  try {
    const match = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&") + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

/**
 * Returns the stored FirstPromoter referral token, or null when the
 * visitor did not arrive through an affiliate link.
 */
export function getFirstPromoterRef(): string | null {
  if (typeof document === "undefined") return null;
  return readCookie(COOKIE_NAME);
}
